// css
import '../../scss/pages/single-news.scss';

// utils
import foundation from '../_utils/foundation';
foundation();

// libs
import Accordion from '../_libs/Accordion';

document.addEventListener('DOMContentLoaded', () => {
	// News カテゴリー切り替え-アコーディオン
	Accordion({
		base: '.js-accordion-category',
		trigger: '.js-accordion-category-trigger',
		target: '.js-accordion-category-target',
		option: false,
	});
});

window.addEventListener('load', () => {});
